<template>
  <v-container>
    <v-row class="text-center" v-show="loading">
      <v-progress-circular
        class="mx-auto loader"
        indeterminate
        color="orange"
        size="75"
      ></v-progress-circular>
    </v-row>

    <v-row v-show="!loading">
      <v-col cols="12" md="4">
        <SelectProfile @select="select"></SelectProfile>
      </v-col>
      <v-col cols="12" md="5">
        <v-text-field
          v-model="term"
          label="Search"
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="text-right" v-show="profile">
        <v-btn class="mx-2" fab dark color="orange" @click="dialog = true">
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-show="!loading">
      <v-col>
        <v-data-table
          :headers="headers"
          :items="notes"
          :search="term"
          @click:row="edit"
        >
          <template v-slot:item.created="{ item }">
            {{ formatDate(item.created, "LL") }}
          </template>
          <template v-slot:item.createdBy="{ item }">
            {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
          </template>
          <template v-slot:item.body="{ item }">
            {{ item.body.substring(0, 100)
            }}<span v-show="item.body.length > 100">...</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Add/Edit Note
        </v-card-title>
        <v-card-text class="mt-6">
          <SelectProfile @select="p => (profile = p)"></SelectProfile>
          <v-text-field v-model="title" label="Title"></v-text-field>
          <v-textarea v-model="body" label="Note"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog = false">Cancel</v-btn>
          <v-btn text color="orange" @click="save">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackText }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import SelectProfile from "@/components/SelectProfile";

export default {
  name: "Notes",
  components: { SelectProfile },
  data() {
    return {
      body: null,
      dialog: false,
      note: {},
      profile: null,
      saving: false,
      snackbar: false,
      snackText: null,
      term: null,
      title: null,
      headers: [
        { text: "Title", value: "title" },
        { text: "Created By", value: "createdBy" },
        { text: "Created", value: "created" },
        { text: "Note", value: "body" }
      ],
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      notes: "notes/getNotes",
      profiles: "profiles/getProfiles",
      user: "users/getUser"
    })
  },
  methods: {
    ...mapActions({
      initUser: "users/initUser",
      listNotes: "notes/listNotes",
      createNote: "notes/createNote",
      deleteNote: "notes/deleteNote",
      updateNote: "notes/updateNote"
    }),
    edit(item) {
      this.note = item;
      this.title = item.title;
      this.body = item.body;
      this.dialog = true;
    },
    formatDate(timestamp) {
      return moment(timestamp).format("LL");
    },
    async remove(item) {
      await this.deleteNote({
        note: item.id,
        profile: this.profile.id
      });
    },
    async save() {
      if (!this.body || !this.title) {
        this.snackbar = true;
        this.snackText = "The Title and Note fields are required.";
        return;
      }
      this.saving = true;
      this.note.body = this.body;
      this.note.title = this.title;

      if (this.note.id) {
        await this.updateNote({
          data: this.note,
          note: this.note.id,
          profile: this.profile.id
        });
      } else {
        await this.createNote({
          data: {
            body: this.body,
            created: Date.now(),
            createdBy: this.user,
            title: this.title
          },
          profile: this.profile.id
        });
      }
      this.note = {};
      this.title = this.body = null;
      this.saving = false;
      this.dialog = false;
      this.select(this.profile);
    },
    async select(profile) {
      this.loading = true;
      this.profile = profile;
      await this.listNotes(this.profile.id);
      this.term = null;
      this.loading = false;
    }
  },
  async mounted() {
    await this.initUser();
    this.loading = false;
  }
};
</script>

<style scoped>
.loader {
  margin-top: 20%;
}
</style>
